import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/users';

export async function signUp(userData) {
  return await sendRequest(`${BASE_URL}/signup`, 'POST', userData);
}

export async function login(credentials) {
  return await sendRequest(`${BASE_URL}/login`, 'POST', credentials);
}

export async function verifyCredentials(id, credentials) {
  return await sendRequest(
    `${BASE_URL}/verify-credentials/${id}`,
    'POST',
    credentials,
  );
}

export async function checkAvailability(credentials) {
  return await sendRequest(
    `${BASE_URL}/check-availability`,
    'POST',
    credentials,
  );
}

export async function getAllUsers() {
  return await sendRequest(BASE_URL, 'GET');
}

export async function getMe() {
  return await sendRequest(`${BASE_URL}/me`, 'GET');
}

export async function addUser(userData) {
  return await sendRequest(BASE_URL, 'POST', userData);
}

export async function updateUser(id, userData) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', userData);
}

export async function updateUserPassword(id, userData) {
  return await sendRequest(
    `${BASE_URL}/${id}/change-password/`,
    'PUT',
    userData,
  );
}

export async function deleteUser(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
